export default __webpack_public_path__ + "static/media/B-T-HTLIFE.8593dfea.svg";